<template>
  <div>
    <ClientForm :closable="false" show-return />
  </div>
</template>

<script>
import ClientForm from "@/components/forms/ClientForm.vue";
import { mapActions } from "vuex";

export default {
  components: {
    ClientForm
  },

  methods: {
    ...mapActions("clients", ["showClient"])
  },

  created() {
    this.showClient(this.$route.params.id);
  }
};
</script>
